<template>
  <roe-error-message :field="design.service_requirement_match_measurement_number">
    <input
      type="number"
      v-model.number="design.$model.service_requirement_match_measurement_number"
      required
    />
    <label class="input-label-inside">months</label>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
export default {
  name: "RoeEmployerMatchServiceRequirementMonthsInput",
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
